export default "__VITE_ASSET__HlkeR7lk__"